import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import {
  IClass3,
  IClassTime2,
} from '../../../models/campusClasses.model';

interface IProps {
  data?: IClass3;
}

const ClassLessonInfo: FC<IProps> = ({ data }) => {
  const { t } = useTranslation();

  if (!data) return <></>;

  const _response = data?.classInfo?.reduce((acc: any,item) => {
    if (acc[item.lessonWeekday]) {
      acc[item.lessonWeekday] = [...acc[item.lessonWeekday], item];
      return acc;
    }

    acc[item.lessonWeekday] = [item];
    return acc;
  }, {})


  return (
    <>
      <div className="comm-bx__between">
        <h3 className='sub-title'>{t('class.class.title3')}</h3>
      </div>
      <div className='comm-table__area rowType stats'>
      <table>
        <colgroup>
          <col width="15%" />
          <col width="5%" />
          <col width="20%" />
          <col width="20%" />
          <col width="20%" />
          <col width="20%" />
        </colgroup>
        <tbody>
          <tr>
            <th className="text-center">{t('class.class.6')}</th>
            <th className="text-center">{t('class.class.column22')}</th>
            <th className="text-center">{t('class.class.7')}</th>
            <th className="text-center">{t('class.class.column23')}</th>
            <th className="text-center">{t('class.class.column24')}</th>
            <th className="text-center">{t('class.class.column25')}</th>
          </tr>
          {
            Object.keys(_response)?.map((key, index) => {
              const classInfo = _response[key];
              return (
                <Fragment key={classInfo.classWeekdayCode}>
                  <tr>
                    <td className="text-center" rowSpan={classInfo.length + 1}>
                      Day {index + 1}
                    </td>
                  </tr>
                  {
                    classInfo?.map((info: any) => {
                      return info?.classTimes?.map((classTime: IClassTime2, subIndex: number) => (
                        <tr key={subIndex}>
                          <td className="text-center">{classTime?.classTimeSeq}</td>
                          <td className="text-center">{classTime?.subjectName}</td>
                          <td className="text-center">{classTime?.srtTime}</td>
                          {
                            classTime?.classRoomList?.map((classRoom: any) => {
                              return <td className="text-center">{classRoom?.classRoomName}</td>
                            })
                          }
                          <td className="text-center">{classTime?.teacherKorName}</td>
                        </tr>
                      ))
                    })
                  }
                </Fragment>
              )
            })
          }
        </tbody>
      </table>
      </div>
    </>
  );
};

export default ClassLessonInfo;
